import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, Transition as _Transition, withCtx as _withCtx, createVNode as _createVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-6c4b40fa"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "intro-steps" }
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = ["innerHTML"]
const _hoisted_4 = ["innerHTML"]

import { computed } from 'vue'
import { useI18n } from 'vue-i18n'

import gsap from 'gsap';

import { Role } from '@/services/states/AppStateMachine';
import { useAppState, useGameState } from '@/services/composition';
import Delay from '@/core/Delay';


export default /*#__PURE__*/_defineComponent({
  props: {
  step: {
    type: Number,
    required: true
  },
  stepCount: {
    type: Number,
    required: true
  }
},
  emits: ["next"],
  setup(__props, { emit }: { emit: ({
  (e: 'next'): void
}), expose: any, slots: any, attrs: any }) {

const props = __props

  const { state } = useAppState()
const { t } = useI18n()



const introType = computed(() => {
  return state.value.context.role === Role.Companion ? 'intro_companion' : 'intro'
})



const onEnter = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.from(el, { opacity: 0, duration: 1 })
  tl.from($('span'), { x: (i) => 96 * (i % 2 === 0 ? 1 : -1), duration: 1, stagger: 0.1 }, 0)
}

const onAfterEnter = async () => {
  // await Delay(1000)
  // emit('next')
}

const onLeave = (el: gsap.DOMTarget, onComplete: gsap.Callback) => {
  const $ = gsap.utils.selector(el)
  const tl = gsap.timeline({ onComplete })
  tl.to(el, { opacity: 0, duration: 1 })
  tl.to($('span'), { x: (i) => 96 * (i % 2 === 0 ? -1 : 1), duration: 1, stagger: 0.1 }, 0)
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_Transition, {
      css: false,
      mode: "out-in",
      onEnter: onEnter,
      onAfterEnter: onAfterEnter,
      onLeave: onLeave,
      appear: ""
    }, {
      default: _withCtx(() => [
        (_openBlock(), _createElementBlock("div", {
          class: "intro-step",
          key: __props.step
        }, [
          _createElementVNode("span", {
            innerHTML: _unref(t)(`${_unref(introType)}.text${__props.step}.line1`)
          }, null, 8, _hoisted_2),
          _createElementVNode("span", {
            innerHTML: _unref(t)(`${_unref(introType)}.text${__props.step}.line2`)
          }, null, 8, _hoisted_3),
          _createElementVNode("span", {
            innerHTML: _unref(t)(`${_unref(introType)}.text${__props.step}.line3`)
          }, null, 8, _hoisted_4)
        ]))
      ]),
      _: 1
    })
  ]))
}
}

})